import Cog from '../icons/Cog';
import { Box, keyframes, Modal as MUIModal, styled } from '@mui/material';

export const Modal = styled(MUIModal)`
  margin: 10px;
  .MuiBackdrop-root {
    background-color: rgba(255, 255, 255, 0.6);
  }
`;

export const ModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  :focus-visible {
    outline: 0;
  }
`;

const rotation = keyframes`
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
`;

export const CogIcon = styled(Cog)`
  animation: ${rotation} 3s infinite linear;
`;
